import { NavItem } from '../../types/known-routes/general.known.routes';
import {
  AdministrationKnownItemId,
  AdministrationKnownRoutes,
} from '../../types/known-routes/administration.known.routes';
import {
  IncidentsKnownItemId,
  IncidentsKnownRoutes,
} from '../../types/known-routes/incidents.known.routes';
import {
  ProviderKnownItemId,
  ProvidersKnownRoutes,
} from '../../types/known-routes/providers.known.routes';
import {
  HospitalsKnownItemId,
  HospitalsKnownRoutes,
} from '../../types/known-routes/hospitals.known.routes';
import {
  PortalsKnownItemId,
  PortalsKnownRoutes,
} from '../../types/known-routes/portals.known.routes';
import {
  ParametricKnownItemId,
  ParametricKnownRoutes,
} from '../../types/known-routes/parametric.known.router';
import {
  HumanTalentTrainingKnownItemId,
  HumanTalentTrainingKnownRoutes,
} from '../../types/known-routes/human-talent-training.known.routes';

export enum KnownPermissions {
  SETTINGS,
  INCIDENTS,
  INCIDENTS_CONFIRM,
  INCIDENTS_CONFIRM_W,
  INCIDENTS_LOCALIZATION,
  INCIDENTS_ROLE_DISTRIBUTION,
  REQUESTERS,
  REQUESTERS_W,
  MEDICAL_REGULATION,
  MEDICAL_REGULATION_W,
  PATIENTS_HANDLING,
  PATIENTS_HANDLING_W,
  PROVIDERS_MODULE,
  HOSPITALS_MODULE,
  REFERENCE_MODULE,
  FOLLOWUP_MODULE,
  PORTALS_MODULE,
  STRETCHER_MODULE,
  POWER_BI,
  HUMAN_TALENT_TRAINING_MODULE,
}

export enum KnownRoles {
  TARM = 'tarm',
  MEDIC_REGULATION = 'medic_regulation',
  MENTAL = 'mental',
  DELIVERY = 'delivery',
  NURSE = 'nurse',
  MEDIAL_AUDIT = 'medical_audit',
  TARM_REFERENCE = 'tarm_reference',
  TARM_EMERGENCY_NETWORK = 'tarm_emergency_network',
  ADMINISTRATOR = 'administrador',
  AUDITOR = 'auditor',
  LEAD_MEDIC = 'lead-medic',
  APH_PROVIDER = 'aph-provider',
  TRANSPORT_MANAGER = 'transport_manager',
  TRANSPORT_COORDINATOR = 'transport_coordinator',
  APH_REFERENT = 'aph_referent',
  INFORMATION_MANAGER = 'information_manager',
  MANAGERS_COORDINATOR = 'managers_coordinator',
  RADIO_COMM = 'radio-comm',
  HOSPITAL = 'hospital',
  LEAD_PORTAL_NURSE = 'lead_portal_nurse',
  PORTAL_AUXILIAR = 'portal_auxiliar',
  PHARM_AUXILIAR = 'medicine_dispenser_auxiliary',
  MECHANICAL_TECHNICAL = 'mechanical_technical',
  COURSE_PARTICIPANT = 'course_participant',
  BIOMEDIC = 'biomedic_engineer',
  LEAD_APH = 'lead_aph',
  DRIVER = 'driver',
  LINK_PROFESSIONAL = 'link_professional',
}

export const RolesToSpanishHash: { [type in KnownRoles]: string } = {
  [KnownRoles.ADMINISTRATOR]: 'Administrador',
  [KnownRoles.TARM]: 'TARM',
  [KnownRoles.TARM_REFERENCE]: 'TARM Referencia',
  [KnownRoles.TARM_EMERGENCY_NETWORK]: 'TARM Red Emergencias',
  [KnownRoles.DELIVERY]: 'Despacho',
  [KnownRoles.MEDIC_REGULATION]: 'Regulación Médica',
  [KnownRoles.MEDIAL_AUDIT]: 'Auditoría Médica',
  [KnownRoles.MENTAL]: 'Salud Mental',
  [KnownRoles.NURSE]: 'Enfermero',
  [KnownRoles.LEAD_MEDIC]: 'Médico Líder',
  [KnownRoles.AUDITOR]: 'Auditoría',
  [KnownRoles.APH_PROVIDER]: 'Prestador',
  [KnownRoles.TRANSPORT_MANAGER]: 'Gestor de transporte',
  [KnownRoles.TRANSPORT_COORDINATOR]: 'Coordinador de transporte',
  [KnownRoles.APH_REFERENT]: 'Referente APH',
  [KnownRoles.INFORMATION_MANAGER]: 'Gestor de Información',
  [KnownRoles.MANAGERS_COORDINATOR]: 'Coordinador de Gestores',
  [KnownRoles.RADIO_COMM]: 'Radiocomunicaciones',
  [KnownRoles.HOSPITAL]: 'Hospital',
  [KnownRoles.LEAD_PORTAL_NURSE]: 'Enfermero lider portal',
  [KnownRoles.PORTAL_AUXILIAR]: 'Auxiliar portal',
  [KnownRoles.PHARM_AUXILIAR]: 'Auxiliar de farmacia',
  [KnownRoles.MECHANICAL_TECHNICAL]: 'Técnico Automotriz',
  [KnownRoles.COURSE_PARTICIPANT]: 'Participante a cursos',
  [KnownRoles.BIOMEDIC]: 'Ingeniero Biomédico',
  [KnownRoles.LEAD_APH]: 'Líder aph',
  [KnownRoles.DRIVER]: 'Conductor',
  [KnownRoles.LINK_PROFESSIONAL]: 'Profesional de Enlace',
};

export const MappedPermissions: {
  [key in KnownPermissions]: {
    keycloakClientRoleName: string[];
    keycloakClientId: string[];
  };
} = {
  [KnownPermissions.SETTINGS]: {
    keycloakClientRoleName: [
      'settings',
      'manage_supplies_equipment',
      'manage_vehicle_tools',
      'providers_module',
      'manage_biomedic_equipments',
      'supplies_equipments_codes_individually',
      'biomedic_equipments_codes_individually',
      'vehicle_tools_codes_individually',
    ],
    keycloakClientId: ['sisem_real_operations_front', 'sisem_real_app_mobile_ms'],
  },
  [KnownPermissions.INCIDENTS]: {
    keycloakClientRoleName: ['incidents'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.INCIDENTS_CONFIRM]: {
    keycloakClientRoleName: ['incidents_confirm'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.INCIDENTS_LOCALIZATION]: {
    keycloakClientRoleName: ['incidents_localization'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.INCIDENTS_ROLE_DISTRIBUTION]: {
    keycloakClientRoleName: ['incidents_role_distribution'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.REQUESTERS]: {
    keycloakClientRoleName: ['requesters'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.MEDICAL_REGULATION]: {
    keycloakClientRoleName: ['medical_regulation'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.PATIENTS_HANDLING]: {
    keycloakClientRoleName: ['patients_handling'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.INCIDENTS_CONFIRM_W]: {
    keycloakClientRoleName: ['incidents_confirm_w'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.REQUESTERS_W]: {
    keycloakClientRoleName: ['requesters_w'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.MEDICAL_REGULATION_W]: {
    keycloakClientRoleName: ['medical_regulation_w'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.PATIENTS_HANDLING_W]: {
    keycloakClientRoleName: ['patients_handling_w'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.PROVIDERS_MODULE]: {
    keycloakClientRoleName: [
      'providers_module',
      'query_clinic_records',
      'manage_vehicle_tools',
      'manage_supplies_equipment',
      'manage_biomedic_equipments',
      'config_preoperational_vehicle',
      'query_clinic_records',
    ],
    keycloakClientId: ['sisem_real_operations_front', 'sisem_real_app_mobile_ms'],
  },
  [KnownPermissions.HOSPITALS_MODULE]: {
    keycloakClientRoleName: ['hospitals_module'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.REFERENCE_MODULE]: {
    keycloakClientRoleName: ['hospitals_module'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.FOLLOWUP_MODULE]: {
    keycloakClientRoleName: ['hospitals_module'],
    keycloakClientId: ['sisem_real_operations_front'],
  },
  [KnownPermissions.STRETCHER_MODULE]: {
    keycloakClientRoleName: ['vehicleRetention_w'],
    keycloakClientId: ['sisem_real_incidents_ms'],
  },
  [KnownPermissions.POWER_BI]: {
    keycloakClientRoleName: ['vehicleRetention_w'],
    keycloakClientId: ['sisem_real_incidents_ms'],
  },
  [KnownPermissions.PORTALS_MODULE]: {
    keycloakClientRoleName: ['patientTransmilenio_r', 'incidentPatientTransmilenioParticular_r'],
    keycloakClientId: ['sisem_real_incidents_ms'],
  },
  [KnownPermissions.HUMAN_TALENT_TRAINING_MODULE]: {
    keycloakClientRoleName: ['human-talent-training_module'],
    keycloakClientId: ['sisem_real_incidents_ms'],
  },
};

export enum KnownSections {
  MANAGE_VEHICLE = 'manageVehicle',
  TRANSFER_VEHICLE = 'transferVehicle',
  MANAGE_BASE = 'manageBases',
  ASSIGN_BASE = 'assignBases',
  SEND_VEHICLES_TO_ACTIVATE = 'sendVehiclesToActivate',
  VEHICLES_TO_VALIDATE = 'vehiclesToValidate',
  CONFIRM_REPS_DATA = 'confirmRepsData',
  INCIDENTS = 'incidents',
  VALIDATE_AVL = 'validateAVL',
  AVL_ACTION = 'AVLAction',
  MANAGE_QR = 'manageQRCode',
  SEARCH_AND_REPORT_STATUS = 'searchAndReportStatus',
  HOSPITALS = 'hospitals',
  MANAGE_PATIENTS = 'managePatients',
  REFERENCE = 'reference',
  FOLLOW_UP = 'followUp',
  PORTALS = 'portals',
  LIST_PORTALS = 'ListPortals',
  STRETCHER = 'stretch',
  IPS_DIRECTORY = 'ips-directory',
  UPDATE_INFORMATION = 'updateInformation',
  POWER_BI = 'updateInformation',
  HUMAN_TALENT_TRAINING = 'humanTalentTraining',
  VEHICLE_TOOL_STOCK = 'vehicleToolStock',
  BIOMEDICAL_EQUIPMENT_STOCK = 'biomedicalEquipmentStock',
  APH_LOG = 'aphLog',
}

// HERE YOU CAN ADD KNOWN ROLES TO ADD PERMISSIONS TO SPECIFIC SECTIONS
export const MappedSectionsRoles: { [k in KnownSections]: KnownRoles[] } = {
  [KnownSections.MANAGE_VEHICLE]: [
    KnownRoles.APH_PROVIDER,
    KnownRoles.APH_REFERENT,
    KnownRoles.ADMINISTRATOR,
    KnownRoles.LINK_PROFESSIONAL,
  ],
  [KnownSections.APH_LOG]: [
    KnownRoles.LEAD_APH,
    KnownRoles.PHARM_AUXILIAR,
    KnownRoles.LINK_PROFESSIONAL,
  ],
  [KnownSections.TRANSFER_VEHICLE]: [KnownRoles.APH_PROVIDER, KnownRoles.TRANSPORT_MANAGER],
  [KnownSections.MANAGE_BASE]: [
    KnownRoles.APH_PROVIDER,
    KnownRoles.TRANSPORT_COORDINATOR,
    KnownRoles.TRANSPORT_MANAGER,
    KnownRoles.INFORMATION_MANAGER,
    KnownRoles.MANAGERS_COORDINATOR,
  ],
  [KnownSections.CONFIRM_REPS_DATA]: [KnownRoles.APH_PROVIDER],
  [KnownSections.INCIDENTS]: [
    KnownRoles.AUDITOR,
    KnownRoles.TARM,
    KnownRoles.TARM_EMERGENCY_NETWORK,
    KnownRoles.TARM_REFERENCE,
    KnownRoles.LEAD_MEDIC,
    KnownRoles.DELIVERY,
    KnownRoles.MENTAL,
    KnownRoles.NURSE,
    KnownRoles.MEDIAL_AUDIT,
    KnownRoles.MEDIC_REGULATION,
    KnownRoles.TRANSPORT_COORDINATOR,
    KnownRoles.TRANSPORT_MANAGER,
    KnownRoles.ADMINISTRATOR,
  ],
  [KnownSections.ASSIGN_BASE]: [KnownRoles.TRANSPORT_MANAGER, KnownRoles.APH_PROVIDER],
  [KnownSections.VALIDATE_AVL]: [KnownRoles.RADIO_COMM],
  [KnownSections.AVL_ACTION]: [KnownRoles.RADIO_COMM],
  [KnownSections.SEND_VEHICLES_TO_ACTIVATE]: [KnownRoles.ADMINISTRATOR],
  [KnownSections.VEHICLES_TO_VALIDATE]: [KnownRoles.INFORMATION_MANAGER],
  [KnownSections.MANAGE_QR]: [KnownRoles.APH_PROVIDER],
  [KnownSections.HOSPITALS]: [
    KnownRoles.LEAD_MEDIC,
    KnownRoles.ADMINISTRATOR,
    KnownRoles.MEDIC_REGULATION,
    KnownRoles.NURSE,
    KnownRoles.TARM_REFERENCE,
    KnownRoles.HOSPITAL,
  ],
  [KnownSections.MANAGE_QR]: [KnownRoles.APH_PROVIDER],
  [KnownSections.SEARCH_AND_REPORT_STATUS]: [KnownRoles.APH_PROVIDER],
  [KnownSections.REFERENCE]: [
    KnownRoles.TARM_REFERENCE,
    KnownRoles.LEAD_MEDIC,
    KnownRoles.MEDIC_REGULATION,
  ],
  [KnownSections.FOLLOW_UP]: [
    KnownRoles.TARM_REFERENCE,
    KnownRoles.LEAD_MEDIC,
    KnownRoles.MEDIC_REGULATION,
  ],
  [KnownSections.MANAGE_PATIENTS]: [KnownRoles.HOSPITAL],
  [KnownSections.STRETCHER]: [
    KnownRoles.TARM_REFERENCE,
    KnownRoles.MEDIC_REGULATION,
    KnownRoles.TRANSPORT_MANAGER,
    KnownRoles.LEAD_MEDIC,
  ],

  [KnownSections.PORTALS]: [KnownRoles.PORTAL_AUXILIAR, KnownRoles.LEAD_PORTAL_NURSE],
  [KnownSections.LIST_PORTALS]: [KnownRoles.LEAD_PORTAL_NURSE, KnownRoles.PORTAL_AUXILIAR],
  [KnownSections.IPS_DIRECTORY]: [KnownRoles.ADMINISTRATOR, KnownRoles.TARM_REFERENCE],
  [KnownSections.UPDATE_INFORMATION]: [KnownRoles.HOSPITAL],
  [KnownSections.POWER_BI]: [KnownRoles.ADMINISTRATOR],
  [KnownSections.HUMAN_TALENT_TRAINING]: [KnownRoles.COURSE_PARTICIPANT],
  [KnownSections.VEHICLE_TOOL_STOCK]: [KnownRoles.MECHANICAL_TECHNICAL],
  [KnownSections.BIOMEDICAL_EQUIPMENT_STOCK]: [KnownRoles.BIOMEDIC],
};

// HERE YOU CAN CHANGE THE MAIN ROUTE WHERE A ROLE WILL BE REDIRECTED
export const MappedLandingRoutes: { [k in KnownRoles]: NavItem } = {
  [KnownRoles.ADMINISTRATOR]: AdministrationKnownRoutes(AdministrationKnownItemId.SUB_PARAMETRICS),
  [KnownRoles.TARM]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.TARM_REFERENCE]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.TARM_EMERGENCY_NETWORK]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.DELIVERY]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.MEDIC_REGULATION]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.MEDIAL_AUDIT]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.MENTAL]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.NURSE]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.LEAD_MEDIC]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.AUDITOR]: IncidentsKnownRoutes(IncidentsKnownItemId.LIST),
  [KnownRoles.APH_PROVIDER]: ProvidersKnownRoutes(ProviderKnownItemId.BASES),
  [KnownRoles.TRANSPORT_MANAGER]: ProvidersKnownRoutes(ProviderKnownItemId.BASES),
  [KnownRoles.TRANSPORT_COORDINATOR]: ProvidersKnownRoutes(ProviderKnownItemId.BASES),
  [KnownRoles.APH_REFERENT]: ProvidersKnownRoutes(ProviderKnownItemId.AGENCIA),
  [KnownRoles.LINK_PROFESSIONAL]: ProvidersKnownRoutes(ProviderKnownItemId.AGENCIA),
  [KnownRoles.INFORMATION_MANAGER]: ProvidersKnownRoutes(ProviderKnownItemId.VEHICLES_TO_VALIDATE),
  [KnownRoles.MANAGERS_COORDINATOR]: ProvidersKnownRoutes(ProviderKnownItemId.BASES),
  [KnownRoles.RADIO_COMM]: ProvidersKnownRoutes(ProviderKnownItemId.VALIDATE_AVL),
  [KnownRoles.HOSPITAL]: HospitalsKnownRoutes(HospitalsKnownItemId.MANAGE_PATIENTS),
  [KnownRoles.LEAD_PORTAL_NURSE]: PortalsKnownRoutes(PortalsKnownItemId.LIST_PORTALS),
  [KnownRoles.PORTAL_AUXILIAR]: PortalsKnownRoutes(PortalsKnownItemId.LIST_PORTALS),
  [KnownRoles.PHARM_AUXILIAR]: ParametricKnownRoutes(ParametricKnownItemId.PARAMETRIC_LIST),
  [KnownRoles.MECHANICAL_TECHNICAL]: ParametricKnownRoutes(ParametricKnownItemId.PARAMETRIC_LIST),
  [KnownRoles.COURSE_PARTICIPANT]: HumanTalentTrainingKnownRoutes(
    HumanTalentTrainingKnownItemId.HUMAN_TALENT_TRAINING_LIST
  ),
  [KnownRoles.BIOMEDIC]: ParametricKnownRoutes(ParametricKnownItemId.PARAMETRIC_LIST),
  [KnownRoles.LEAD_APH]: ProvidersKnownRoutes(ProviderKnownItemId.MANAGE_DEVICE_RESOURCE),
  [KnownRoles.DRIVER]: ParametricKnownRoutes(ParametricKnownItemId.PARAMETRIC_LIST),
};
